// extracted by mini-css-extract-plugin
export default {"subheadline":"ContactCard_subheadline__7Shby","headline":"ContactCard_headline__yz91U","card":"ContactCard_card__jZyWY"};